import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import alegriaImg from '../../assets/images/timeline/paineissolares.jpg';

const styles = {
  width: "75%",
  height: "978px",
  position: "absolute",
  top: "109px"
};

const MapboxGLMap = (props) => {
  const [map, setMap] = useState(null);
  const mapContainer = useRef(null);

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoicmljYXJkb21hcml6IiwiYSI6ImNqcnRud2ZjazAza2YzeW80ZGF1MGM2MGYifQ.002bk0MBgNb5Vo-n4olFYQ';
    const initializeMap = ({ setMap, mapContainer }) => {
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/tiagocolucci/cjrkztd5r05o82sqtloa0zu5x", // stylesheet location
        center: [-37.412, -17.696],
        zoom: 4,
        interactive: true
      });

      let popupSignal = 11;

      props.windfarms.forEach((windfarm, index) => {
        const alegriaPopup = new mapboxgl.Popup({ offset: 25, className: 'popups' }).setHTML(
          `<div class="popups-container"> 
              <div class="popups-solar-title">
                <h3> ${windfarm.Project} </h3>
                <p> ${windfarm.State}  </p> 
              </div>
              <div class="popups-img">
                <img src="${alegriaImg}" />
              </div>
              <div class="basic-info"> 
                <p> <b>Total Capacity: </b>${windfarm.MW}</p>
                <p> <b>Supplier: </b>${windfarm.Supplier} </p>
                <p> <b>Year: </b>${windfarm.Year} </p>
                <p> <b>Status: </b>${windfarm.Status} </p>
                ${windfarm.Status !== 'Operating' ? '<button type="button" disabled> Sold/In Construction</button>' : ''}
              </div>
          </div>`
        )
        .on('open', function(){
          popupSignal += 1
          map.flyTo({center: [windfarm.Longitude, windfarm.Latitude], zoom: 13});
        })
        .on('close', function(){
          if (popupSignal > 0) {
            popupSignal -= 1
          }
          if (popupSignal <= 0) {
            map.flyTo({center: [windfarm.Longitude, windfarm.Latitude], zoom: 5});
            return
          }
        });

        new mapboxgl.Marker({ "color": "#b43855" })
          .setLngLat([windfarm.Longitude, windfarm.Latitude])
          .setPopup(alegriaPopup)
          .addTo(map);
      });
      

      map.on("load", () => {
        setMap(map);
        map.resize();
      });
    };

    if (!map) initializeMap({ setMap, mapContainer });
  }, [map, props.windfarms]);

  return <div ref={el => (mapContainer.current = el)} style={styles} />;
};

export default MapboxGLMap;
